<template>
  <v-dialog transition="scale-transition" origin="center center" max-width="460" v-model="dialogDeposit"
    content-class="deposit-withdraw-popup marketingPopup">
    <template v-slot:activator="{ on, attrs }">
      <span class="text-decoration-none" v-bind="attrs" v-on="on">Deposit Funds</span>
    </template>
    <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
      <v-card-title class="pb-3 text-left justify-start pl-3">
        Deposit
      </v-card-title>
      <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
        Deposit Money From Here
      </v-card-subtitle>
      <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
        <v-row>
          <v-col cols="12">
            <fieldset>
              <legend>Trading Account*</legend>
              <v-select v-model="formData.tradingAccount" solo :items="tradingAcc" item-text="text" item-value="value"
                append-icon="mdi-chevron-down" label="Select Your Acc." class="custom-select" hide-details></v-select>
            </fieldset>
          </v-col>
          <v-col cols="12">
            <fieldset>
              <legend>Payment Method*</legend>
              <v-select v-model="selectedPaymentMethod" solo :items="depositPaymentSystem" item-text="text"
                item-value="value" append-icon="mdi-chevron-down" label="Click to Select" class="custom-select"
                hide-details @change="resetFormData"></v-select>
            </fieldset>
          </v-col>
          <v-col cols="12">
            <fieldset>
              <legend>Amount*</legend>
              <v-text-field v-model="formData.amount" label="Enter Amount" single-line solo hide-details
                class="custom-select"></v-text-field>
            </fieldset>
          </v-col>
          <v-col cols="12">
            <fieldset>
              <legend>Transaction ID*</legend>
              <v-text-field v-model="formData.transactionId" label="Enter Transaction Id" single-line solo hide-details
                class="custom-select"></v-text-field>
            </fieldset>
          </v-col>
          <!-- Dynamic fields based on payment method -->
          <template v-for="field in getPaymentMethodFields()">
            <v-col :key="field.name" cols="12">
              <fieldset>
                <legend>{{ field.label }}</legend>
                <v-text-field v-if="field.type !== 'select'" v-model="formData[field.name]" :label="field.placeholder"
                  single-line solo hide-details class="custom-select"></v-text-field>
                <v-select v-else v-model="formData[field.name]" :items="field.options" :label="field.placeholder" solo
                  hide-details class="custom-select"></v-select>
              </fieldset>
            </v-col>
          </template>
        </v-row>
      </v-card>
      <v-card-actions>
        <v-row dense>
          <v-col cols="12">
            <v-btn tile @click="submitForm" elevation="0" class="text-capitalize btn-account mr-3 px-sm-8"
              color="greenMain">Confirm</v-btn>
            <v-btn tile color="#FF567F" @click="dialogDeposit = false" elevation="0"
              class="text-capitalize btn-account px-sm-8">Cancel</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  REGISTERUSERDETAILS__ACTIONS
} from "@/store/action-types";

export default {
  data() {
    return {
      userId: null,
      dialogDeposit: false,
      selectedPaymentMethod: null,
      formData: {
        tradingAccount: '',
        amount: '',
        transactionId: ''
      },
    };
  },
  computed: {
    ...mapState("reguserdetails", ["tradingAcc", "depositPaymentSystem"]),
  },
  methods: {
    ...mapActions("reguserdetails", [REGISTERUSERDETAILS__ACTIONS.PAYMENTSYSTEMFORDEPOSIT, REGISTERUSERDETAILS__ACTIONS.CLIENTTRADINGACCOUNTS, REGISTERUSERDETAILS__ACTIONS.CREATECLIENTDEPOSIT]),
    resetFormData() {
      this.formData = {
        tradingAccount: this.formData.tradingAccount,
        amount: '',
        transactionId: ''
      };
      // Clear any custom fields
      const customFields = this.getPaymentMethodFields();
      customFields.forEach(field => {
        this.$set(this.formData, field.name, '');
      });
    },

    getPaymentMethodFields() {
      const selectedMethod = this.depositPaymentSystem.find(method => method.value === this.selectedPaymentMethod);
      if (!selectedMethod) return [];

      switch (selectedMethod.pretty_name) {
        case 'custom-deposit': // Custom Deposit, Custom Withdraw
          return [
            { name: 'comment', label: 'Comment', placeholder: 'Enter Comment', type: 'text' },
          ];
        case 'custom-withdraw': // Custom Deposit, Custom Withdraw
          return [
            { name: 'comment', label: 'Comment', placeholder: 'Enter Comment', type: 'text' },
          ];
        case 'bank-transfer': // Bank Transfer
          return [
            { name: 'bankName', label: 'Bank Name', placeholder: 'Enter Bank Name', type: 'text' },
            { name: 'accountName', label: 'Account Name', placeholder: 'Enter Account Name', type: 'text' },
            { name: 'iban', label: 'IBAN', placeholder: 'Enter IBAN', type: 'text' },
            { name: 'swiftCode', label: 'SWIFT Code', placeholder: 'Enter SWIFT Code', type: 'text' },
            { name: 'comment', label: 'Comment', placeholder: 'Enter Comment', type: 'text' },
          ];
        case 'debit-credit-cards': // Debit/Credit Cards
          return [
            { name: 'cardNumber', label: 'Card Number', placeholder: 'Enter Card Number', type: 'text' },
            { name: 'expiryDate', label: 'Expiry Date', placeholder: 'MM/YY', type: 'text' },
            { name: 'cvv', label: 'CVV', placeholder: 'Enter CVV', type: 'text' },
            { name: 'comment', label: 'Comment', placeholder: 'Enter Comment', type: 'text' },
          ];
        case 'neteller': // Neteller, Skrill
          return [
            { name: 'email', label: 'Email', placeholder: 'Enter Email', type: 'email' },
            { name: 'comment', label: 'Comment', placeholder: 'Enter Comment', type: 'text' },
          ];
        case 'skrill': // Neteller, Skrill
          return [
            { name: 'email', label: 'Email', placeholder: 'Enter Email', type: 'email' },
            { name: 'comment', label: 'Comment', placeholder: 'Enter Comment', type: 'text' },
          ];
        case 'crypto-transfer': // Crypto, Internal Transfer
          return [
            { name: 'walletAddress', label: 'Wallet Address', placeholder: 'Enter Wallet Address', type: 'text' },
            { name: 'comment', label: 'Comment', placeholder: 'Enter Comment', type: 'text' },
          ];
        default:
          return [
            { name: 'comment', label: 'Comment', placeholder: 'Enter Comment', type: 'text' },
          ];
      }
    },

    submitForm() {
      const formData = {
        ...this.formData,
        paymentMethodId: this.selectedPaymentMethod,
        client_account_id: this.userId
      };
      this[REGISTERUSERDETAILS__ACTIONS.CREATECLIENTDEPOSIT](formData)
      this.dialogDeposit = false;
    },
  },
  mounted() {
    this.userId = this.$route.params.id;
    this[REGISTERUSERDETAILS__ACTIONS.PAYMENTSYSTEMFORDEPOSIT]();
    this[REGISTERUSERDETAILS__ACTIONS.CLIENTTRADINGACCOUNTS](this.$route.params.id);
  },
};
</script>